import { AuthenticationAssuranceLevel, ScopeType, AuditPolicy, IdempotencyPolicy, ConcurrencyPolicy, PrivacyClassification, ActorType, } from './operation.js';
/** Canonical operations for platform-scoped primary workspaces. */
export const PLATFORM_DASHBOARD_READ = 'platform.dashboard.read';
export const PLATFORM_DATA_HUB_READ = 'platform.data-hub.read';
export const PLATFORM_REPORTS_READ = 'platform.reports.read';
function platformWorkspaceRead(id, name, labelKey, descriptionKey, module, requiredModules = []) {
    return {
        id,
        name,
        labelKey,
        descriptionKey,
        // Platform reference-data reads currently use the canonical instrument-read
        // grant. A dedicated grant can replace this once platform roles are migrated,
        // without changing route or operation identity.
        permission: id === PLATFORM_DASHBOARD_READ
            ? 'platform:health:read'
            : 'organization:instruments:read',
        permissionId: id === PLATFORM_DASHBOARD_READ
            ? 'platform:health:read'
            : 'organization:instruments:read',
        module,
        ...(requiredModules.length > 0 ? { requiredModules: [...requiredModules] } : {}),
        requiresEntitledModule: id !== PLATFORM_DASHBOARD_READ,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.SYSTEM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM'],
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN', 'PLATFORM_USER'],
        ownershipPolicy: 'PLATFORM',
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: id,
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
        delegationPolicy: 'NOT_ALLOWED',
        accessType: 'READ',
    };
}
export const DASHBOARD_OPERATIONS = {
    [PLATFORM_DASHBOARD_READ]: platformWorkspaceRead(PLATFORM_DASHBOARD_READ, 'View Platform Dashboard', 'operations.platform.dashboard.read.label', 'operations.platform.dashboard.read.description', 'PLATFORM'),
    [PLATFORM_DATA_HUB_READ]: platformWorkspaceRead(PLATFORM_DATA_HUB_READ, 'View Platform Data Hub', 'operations.platform.dataHub.read.label', 'operations.platform.dataHub.read.description', 'DATA', ['DATA', 'INSTRUMENTS']),
    [PLATFORM_REPORTS_READ]: platformWorkspaceRead(PLATFORM_REPORTS_READ, 'View Platform Reports', 'operations.platform.reports.read.label', 'operations.platform.reports.read.description', 'REPORTING', ['REPORTING', 'INSTRUMENTS']),
};
